import { Card, CardContent, LinearProgress, Box } from "@mui/material";
import { useState } from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  animation: ${fadeIn} 1s ease;
`;

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  width: 100%;
`;

const Question = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;

  @media (max-width: 767px) {
    font-size: 1rem;
  }
`;

const Subtext = styled.p`
  font-size: 1rem;
  font-weight: 400;

  @media (max-width: 767px) {
    font-size: 0.8rem;
  }
`;

const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

const Option = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px;
  font-weight: 400;

  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

const Input = styled.input`
  margin-right: 5px;
  &:hover {
    cursor: pointer;
    border-color: #2196f3;
  }

  &:focus {
    outline: none;
    border-color: #2196f3;
    box-shadow: 0px 0px 3px rgba(33, 150, 243, 0.5);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 5px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 5px;
  border: 1px solid #ccc;

  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  border: none;
  background-color: #2196f3;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: #0d8bf2;
  }

  &:focus {
    outline: none;
    background-color: #0d8bf2;
  }

  @media (max-width: 767px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;

const CardWrapper = styled.div`
  width: 100%;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: translateY(-5px);
  }
`;

const FormBuilder3 = ({ questions }) => {
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});

  const getProgressPercentage = () => {
    return ((activeQuestionIndex + 1) / questions.length) * 100;
  };

  const handleInputChange = (questionId, value) => {
    setAnswers({ ...answers, [questionId]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    console.log(answers);
    // Send the answers to the server
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Box sx={{ width: "100%", marginBottom: 2 }}>
        <LinearProgress variant="determinate" value={getProgressPercentage()} />
      </Box>
      {Object.values(questions).map((question) => (
        <CardWrapper>
          <Card sx={{ width: "100%" }}>
            <CardContent>
              <QuestionContainer key={question.id}>
                <Question>{question.question}</Question>
                {question.subtext && <Subtext>{question.subtext}</Subtext>}
                {question.type === "radio" && (
                  <OptionContainer>
                    {question.choice.map((option, index) => (
                      <Option key={index}>
                        <Input
                          type="radio"
                          name={question.id}
                          value={option}
                          required={question.required}
                          // checked={answers[question.id] === option}
                          onChange={(e) =>
                            handleInputChange(question.id, e.target.value)
                          }
                        />
                        {option}
                      </Option>
                    ))}
                  </OptionContainer>
                )}
                {question.type === "check" && (
                  <OptionContainer>
                    {question.choice.map((option, index) => (
                      <Option key={index}>
                        <Input
                          type="checkbox"
                          name={question.id}
                          value={option}
                          checked={
                            answers[question.id] &&
                            answers[question.id].includes(option)
                          }
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            if (isChecked) {
                              handleInputChange(question.id, [
                                ...(answers[question.id] || []),
                                option,
                              ]);
                            } else {
                              handleInputChange(
                                question.id,
                                (answers[question.id] || []).filter(
                                  (opt) => opt !== option
                                )
                              );
                            }
                          }}
                        />
                        {option}
                      </Option>
                    ))}
                  </OptionContainer>
                )}
                {question.type === "text" && (
                  <TextArea
                    placeholder={question.placeholder}
                    required={question.required}
                    value={answers[question.id] || ""}
                    onChange={(e) =>
                      handleInputChange(question.id, e.target.value)
                    }
                  />
                )}
              </QuestionContainer>
            </CardContent>
          </Card>
        </CardWrapper>
      ))}
      <SubmitButton type="submit">Submit</SubmitButton>
    </Form>
  );
};

export default FormBuilder3;
